import React from "react";

import { MenuItem, Select, Typography } from "@mui/material";
import { CountryCode } from "libphonenumber-js";

import { countryCodeList } from "@assets/countryCode/countryCodeList";
import flagPlaceHolder from "@assets/countryCode/img/flag_placeholder.png";

//css for country flag icons
import "@assets/countryCode/css/flag.css";

interface Props {
  value: CountryCode;
  onChange: (country: CountryCode) => void;
}

const MobileInputCountryPicker2: React.FC<Props> = ({ value, onChange }) => {
  return (
    <Select
      value={value}
      onChange={(e) => onChange(e.target.value as CountryCode)}
      renderValue={(value) => (
        <img
          src={flagPlaceHolder}
          className={`flag flag-${(value as string).toLowerCase()}`}
        />
      )}
      variant="standard"
      disableUnderline
      autoWidth
    >
      {countryCodeList.map((c) => (
        <MenuItem key={c.isoCode} value={c.isoCode}>
          <Typography>
            <img
              src={flagPlaceHolder}
              alt={c.name}
              className={`flag flag-${c.isoCode.toLowerCase()}`}
            />
            &emsp;
            {c.name}{" "}
            <Typography variant="caption" style={{ opacity: 0.8 }}>
              {c.dialCode}
            </Typography>
          </Typography>
        </MenuItem>
      ))}
    </Select>
  );
};

export default MobileInputCountryPicker2;
